import React from 'react';
import { Link } from 'react-router-dom';
import { FaUtensils, FaSpa, FaShoppingBag, FaBriefcase } from 'react-icons/fa';

const services = [
{
  title: {
    en: 'Event Catering',
    am: 'ለፕሮግራሞች የምግብ አገልግሎት'
  },
  description: {
    en: 'Food and beverage service for weddings, birthdays, and events.',
    am: 'ለጋብቻ፣ ለየልደት እና ለሌሎች ዝግጅቶች የምግብ እና የመጠጥ አገልግሎት።'
  },
  icon: <FaUtensils size={28} className="text-primary" />
},
{
  title: {
    en: 'Moroccan Bath',
    am: 'የሞሮካን ገላ እጥብት'
  },
  description: {
    en: 'Steam-based cleansing and relaxation experience.',
    am: 'በእንፋሎት የሰውነት እጥብት እና የማረፊያ ልምድ።'
  },
  icon: <FaSpa size={28} className="text-primary" />
},
{
  title: {
    en: 'On-site Shops',
    am: 'በቦታው ላይ ያሉ ሱቆች'
  },
  description: {
    en: 'Includes sports jersey shoop, salon, and photo studio services.',
    am: 'የስፖርት ዕቃዎች መደብር ፣ የፀጉር እና የፎቶ ስቱዲዮ አገልግሎቶችን ያጠቃልላል።'
  },
  icon: <FaShoppingBag size={28} className="text-primary" />
},
{
  title: {
    en: 'VIP Conference Rooms',
    am: 'ቪአይፒ የስብሰባ ክፍሎች'
  },
  description: {
    en: 'Fully equipped and elegant meeting rooms.',
    am: 'ዘመናዊ የስብሰባ ክፍሎች።'
  },
  icon: <FaBriefcase size={28} className="text-primary" />
}
];

const OtherServices = ({ language }) => {
  return (
    <section className="container py-5">
<h2 className="fw-bold text-center mb-4">
  {language === 'en' ? 'Other Services' : 'ሌሎች አገልግሎቶች'}
</h2>      <div className="row g-4">
        {services.map((service, index) => (
          <div key={index} className="col-md-6 col-lg-3">
            <div className="card h-100 shadow-sm border-0">
              <div className="card-body text-center">
                <div className="mb-3">{service.icon}</div>
                <h5 className="card-title fw-bold">{service.title[language]}</h5>
                <p className="card-text small">{service.description[language]}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-center mt-4">
     <Link to="/other-services" className="btn btn-outline-primary">
  {language === 'en' 
    ? 'Learn More About These Services' 
    : 'ስለእነዚህ አገልግሎቶች ተጨማሪ ይወቁ'}
</Link>
      </div>
    </section>
  );
};

export default OtherServices;
